import * as yup from "yup";
import { regExpValues } from "./schoolTypes";
import { regExDesignation } from "./designationValues";

// ✅ UPDATED PHONE SCHEMA (GLOBAL FIX)
export const phoneNumberSchema = yup
  .string()
  .required("Phone number is required")
  .test("only-digits", "Phone number must contain only digits", (value) => {
    return /^[0-9]+$/.test(value || "");
  })
  .test("valid-length", function (value) {
    const { phoneLength } = this.options.context || {};

    if (!value) return false;

    const length = phoneLength || 10;

    if (value.length !== length) {
      return this.createError({
        message: `Phone number must be ${length} digits`
      });
    }

    return true;
  });

export const emailSchema = yup
  .string()
  .matches(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.(com|org|in|edu)$/i, "Email ID is not valid");

export const schoolNameSchema = yup
  .string()
  .matches(/^[^-\s][a-zA-Z0-9_\s-]+$/, { message: 'Use only "a-z", "A-Z" characters' });

export const passwordSchema = yup.string().min(5);

export const nameSchema = yup
  .string()
  .max(20, "More than 20 characters are not allowed")
  .matches(/^[a-zA-Z][a-zA-Z0-9_\s-]*$/, { message: 'Use only "a-z", "A-Z" characters' });

export const otpCodeSchema = yup.mixed().nullable();

export const otpVerifiedSchema = yup.boolean();

export const invitationCodeSchema = yup.string().matches(/[a-zA-Z0-9]{4}[-][a-zA-Z0-9]{6}[-][a-zA-Z0-9]{6}$/g, {
  message: "Invalid format code, XXXX-XXXXX-XXXXX"
});

export const schoolTypesSchema = yup.string().matches(regExpValues).required();

export const designationSchema = yup.string().matches(regExDesignation).required();

export const gradeNameSchema = yup.string().matches("[1-9]", {
  message: "Please select grade"
});

export const admissionIDSchema = yup
  .string()
  .matches(/[a-zA-Z0-9]$/g, { message: "Invalid Login ID" })
  .min(6, "Login ID must be atleast 6 characters");

export const udiseCodeSchema = yup
  .string()
  .nullable()
  .optional()
  .transform((value) => (value === "" ? null : value))
  .test("udise-length", "UDISE Code must be 11 digits", (value) => {
    if (!value || value.trim() === "") return true;
    return /^\d{11}$/.test(value);
  });
